module.exports = __webpack_public_path__ + "static/media/esb.5bf00ac7.png";